import { createStoresWithStorage } from '@child-nav/shared/stores/childNavStores';
import { webStorageAdapter } from './WebStorageAdapter';

// Create stores with web storage (IndexedDB + localStorage fallback)
export const {
  useUserStore,
  useMilestonesStore,
  useConcernsStore,
  useWellVisitsStore,
  useActionsStore,
  useProfileStore,
  useContentStore,
} = createStoresWithStorage(webStorageAdapter);

// Re-export types for convenience
export type {
  MilestonesState,
  ConcernsState,
  WellVisitsState,
  ActionsState,
  Milestone,
  Concern,
  WellVisit,
  ActionItem,
  StorageInterface,
} from '@child-nav/shared/stores/childNavStores';

// Re-export content types
export type {
  ContentRecord,
  ContentQuery,
  ContentStoreState,
  ContentType,
  LanguageType,
} from '@child-nav/shared/stores/contentStore';

// Re-export user types from the new user architecture
export type {
  UserState,
  AppUser,
  FamilyAccount,
  UserSession,
} from '@child-nav/shared/types/user';

// Re-export user store
export type { UserStore } from '@child-nav/shared/stores/userStore';